module.exports = __webpack_public_path__ + "img/cottage-pie.a85d6b27.jpg";